export const subCategoryListTranslations = {
  cz: {
    subCategoryListTitle: "Seznam podkategorií",
    name: "Název podkategorie",
    category: "Kategorie",
    subcategoriesButton: "Podkategorie",
    addSubCategoryButton: "+ Přidat podkategorii",
    deleteSubCategoryConfirmation:
      "Opravdu chcete smazat podkategorii '{label}'?",
    searchPlaceholder: "Hledat...",
  },
  en: {
    subCategoryListTitle: "List of Subcategories",
    name: "Subcategory Name",
    category: "Category",
    subcategoriesButton: "Subcategories",
    addSubCategoryButton: "+ Add Subcategory",
    deleteSubCategoryConfirmation:
      "Are you sure you want to delete the subcategory '{label}'?",
    searchPlaceholder: "Search...",
  },
  de: {
    subCategoryListTitle: "Liste der Unterkategorien",
    name: "Name der Unterkategorie",
    category: "Kategorie",
    subcategoriesButton: "Unterkategorien",
    addSubCategoryButton: "+ Unterkategorie hinzufügen",
    deleteSubCategoryConfirmation:
      "Sind Sie sicher, dass Sie die Unterkategorie '{label}' löschen möchten?",
    searchPlaceholder: "Suchen...",
  },
  es: {
    subCategoryListTitle: "Lista de subcategorías",
    name: "Nombre de la subcategoría",
    category: "Categoría",
    subcategoriesButton: "Subcategorías",
    addSubCategoryButton: "+ Añadir subcategoría",
    deleteSubCategoryConfirmation:
      "¿Está seguro de que desea eliminar la subcategoría '{label}'?",
    searchPlaceholder: "Buscar...",
  },
  fr: {
    subCategoryListTitle: "Liste des sous-catégories",
    name: "Nom de la sous-catégorie",
    category: "Catégorie",
    subcategoriesButton: "Sous-catégories",
    addSubCategoryButton: "+ Ajouter une sous-catégorie",
    deleteSubCategoryConfirmation:
      "Êtes-vous sûr de vouloir supprimer la sous-catégorie '{label}'?",
    searchPlaceholder: "Rechercher...",
  },
  hu: {
    subCategoryListTitle: "Alkategóriák listája",
    name: "Alkategória neve",
    category: "Kategória",
    subcategoriesButton: "Alkategóriák",
    addSubCategoryButton: "+ Alkategória hozzáadása",
    deleteSubCategoryConfirmation: "Biztosan törli az alkategóriát '{label}'?",
    searchPlaceholder: "Keresés...",
  },
  nl: {
    subCategoryListTitle: "Lijst met subcategorieën",
    name: "Naam van de subcategorie",
    category: "Categorie",
    subcategoriesButton: "Subcategorieën",
    addSubCategoryButton: "+ Subcategorie toevoegen",
    deleteSubCategoryConfirmation:
      "Weet u zeker dat u de subcategorie '{label}' wilt verwijderen?",
    searchPlaceholder: "Zoeken...",
  },
  pl: {
    subCategoryListTitle: "Lista podkategorii",
    name: "Nazwa podkategorii",
    category: "Kategoria",
    subcategoriesButton: "Podkategorie",
    addSubCategoryButton: "+ Dodaj podkategorię",
    deleteSubCategoryConfirmation:
      "Czy na pewno chcesz usunąć podkategorię '{label}'?",
    searchPlaceholder: "Szukaj...",
  },
  ru: {
    subCategoryListTitle: "Список подкатегорий",
    name: "Название подкатегории",
    category: "Категория",
    subcategoriesButton: "Подкатегории",
    addSubCategoryButton: "+ Добавить подкатегорию",
    deleteSubCategoryConfirmation:
      "Вы уверены, что хотите удалить подкатегорию '{label}'?",
    searchPlaceholder: "Поиск...",
  },
  sk: {
    subCategoryListTitle: "Zoznam podkategórií",
    name: "Názov podkategórie",
    category: "Kategória",
    subcategoriesButton: "Podkategórie",
    addSubCategoryButton: "+ Pridať podkategóriu",
    deleteSubCategoryConfirmation:
      "Naozaj chcete odstrániť podkategóriu '{label}'?",
    searchPlaceholder: "Hľadať...",
  },
  sv: {
    subCategoryListTitle: "Lista över underkategorier",
    name: "Namn på underkategori",
    category: "Kategori",
    subcategoriesButton: "Underkategorier",
    addSubCategoryButton: "+ Lägg till underkategori",
    deleteSubCategoryConfirmation:
      "Är du säker på att du vill ta bort underkategorin '{label}'?",
    searchPlaceholder: "Sök...",
  },
  no: {
    subCategoryListTitle: "Liste over underkategorier",
    name: "Navn på underkategori",
    category: "Kategori",
    subcategoriesButton: "Underkategorier",
    addSubCategoryButton: "+ Legg til underkategori",
    deleteSubCategoryConfirmation:
      "Er du sikker på at du vil slette underkategorien '{label}'?",
    searchPlaceholder: "Søk...",
  },
  da: {
    subCategoryListTitle: "Liste over underkategorier",
    name: "Navn på underkategori",
    category: "Kategori",
    subcategoriesButton: "Underkategorier",
    addSubCategoryButton: "+ Tilføj underkategori",
    deleteSubCategoryConfirmation:
      "Er du sikker på, at du vil slette underkategorien '{label}'?",
    searchPlaceholder: "Søg...",
  },
  fi: {
    subCategoryListTitle: "Luettelo alaluokista",
    name: "Alaluokan nimi",
    category: "Kategoria",
    subcategoriesButton: "Alaluokat",
    addSubCategoryButton: "+ Lisää alaluokka",
    deleteSubCategoryConfirmation:
      "Oletko varma, että haluat poistaa alaluokan '{label}'?",
    searchPlaceholder: "Hae...",
  },
  ar: {
    subCategoryListTitle: "قائمة الفئات الفرعية",
    name: "اسم الفئة الفرعية",
    category: "الفئة",
    subcategoriesButton: "الفئات الفرعية",
    addSubCategoryButton: "+ إضافة فئة فرعية",
    deleteSubCategoryConfirmation:
      "هل أنت متأكد أنك تريد حذف الفئة الفرعية '{label}'؟",
    searchPlaceholder: "بحث...",
  },
};

export default subCategoryListTranslations;
